export default __webpack_public_path__ + "static/media/webdesign.7536800a.svg";